/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EvaluationType } from './EvaluationType';
import {
    EvaluationTypeFromJSON,
    EvaluationTypeFromJSONTyped,
    EvaluationTypeToJSON,
} from './EvaluationType';
import type { QuantityValueType } from './QuantityValueType';
import {
    QuantityValueTypeFromJSON,
    QuantityValueTypeFromJSONTyped,
    QuantityValueTypeToJSON,
} from './QuantityValueType';
import type { AnalysisResultDtoAirPressureFault } from './AnalysisResultDtoAirPressureFault';
import {
    AnalysisResultDtoAirPressureFaultFromJSON,
    AnalysisResultDtoAirPressureFaultFromJSONTyped,
    AnalysisResultDtoAirPressureFaultToJSON,
} from './AnalysisResultDtoAirPressureFault';

/**
 * 
 * @export
 * @interface FaultyNumericValueDto
 */
export interface FaultyNumericValueDto {
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FaultyNumericValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FaultyNumericValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FaultyNumericValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof FaultyNumericValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    numericId?: string;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    defaultValue?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    unitAbbreviation?: string | null;
    /**
     * 
     * @type {QuantityValueType}
     * @memberof FaultyNumericValueDto
     */
    valueType?: QuantityValueType;
    /**
     * 
     * @type {EvaluationType}
     * @memberof FaultyNumericValueDto
     */
    evaluationType?: EvaluationType;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {GeometryLabelDto}
     * @memberof FaultyNumericValueDto
     */
    geometry?: GeometryLabelDto;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    max?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FaultyNumericValueDto
     */
    min?: number | null;
    /**
     * 
     * @type {AnalysisResultDtoAirPressureFault}
     * @memberof FaultyNumericValueDto
     */
    fault?: AnalysisResultDtoAirPressureFault | null;
    /**
     * 
     * @type {string}
     * @memberof FaultyNumericValueDto
     */
    $type?: FaultyNumericValueDtoTypeEnum;
}


/**
 * @export
 */
export const FaultyNumericValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoFaultyNumericValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.FaultyNumericValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type FaultyNumericValueDtoTypeEnum = typeof FaultyNumericValueDtoTypeEnum[keyof typeof FaultyNumericValueDtoTypeEnum];



/**
 * Check if a given object implements the FaultyNumericValueDto interface.
 */
export function instanceOfFaultyNumericValueDto(value?: unknown): value is FaultyNumericValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(FaultyNumericValueDtoTypeEnum)[0];
}

export function FaultyNumericValueDtoFromJSON(json: any): FaultyNumericValueDto {
    return FaultyNumericValueDtoFromJSONTyped(json, false);
}

export function FaultyNumericValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaultyNumericValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'value': json['value'] == null ? undefined : json['value'],
        'numericId': json['numericId'] == null ? undefined : json['numericId'],
        'defaultValue': json['defaultValue'] == null ? undefined : json['defaultValue'],
        'unitAbbreviation': json['unitAbbreviation'] == null ? undefined : json['unitAbbreviation'],
        'valueType': json['valueType'] == null ? undefined : QuantityValueTypeFromJSON(json['valueType']),
        'evaluationType': json['evaluationType'] == null ? undefined : EvaluationTypeFromJSON(json['evaluationType']),
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'geometry': json['geometry'] == null ? undefined : GeometryLabelDtoFromJSON(json['geometry']),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        'max': json['max'] == null ? undefined : json['max'],
        'min': json['min'] == null ? undefined : json['min'],
        'fault': json['fault'] == null ? undefined : AnalysisResultDtoAirPressureFaultFromJSON(json['fault']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function FaultyNumericValueDtoToJSON(value?: FaultyNumericValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'value': value['value'],
        'numericId': value['numericId'],
        'defaultValue': value['defaultValue'],
        'unitAbbreviation': value['unitAbbreviation'],
        'valueType': QuantityValueTypeToJSON(value['valueType']),
        'evaluationType': EvaluationTypeToJSON(value['evaluationType']),
        'decimalPlaces': value['decimalPlaces'],
        'geometry': GeometryLabelDtoToJSON(value['geometry']),
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        'max': value['max'],
        'min': value['min'],
        'fault': AnalysisResultDtoAirPressureFaultToJSON(value['fault']),
        '$type': value['$type'],
    });
}

